import React from "react";
import { Eye } from "lucide-react";
import { cn } from "@/lib/utils";
import { usePreview, type PreviewEntity } from "./PreviewContext";

/** The small eye next to a record's name in a list: opens the quick look without leaving the list */
export function PreviewButton({ entity, id, label, className }: { entity: PreviewEntity; id: string; label: string; className?: string }) {
  const { open } = usePreview();
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        open(entity, id);
      }}
      aria-label={`Quick look at ${label}`}
      title="Quick look"
      className={cn("inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded text-muted-foreground opacity-0 transition-opacity hover:bg-muted hover:text-foreground focus-visible:opacity-100 group-hover/row:opacity-100 [@media(hover:none)]:opacity-100", className)}
    >
      <Eye className="size-3.5" />
    </button>
  );
}
